var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/pro-light-svg-icons/faCircle';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons/faExclamationCircle';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
import { faTimesCircle } from '@fortawesome/pro-solid-svg-icons/faTimesCircle';
import { Header4 } from './typography';
var Step = styled.li(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  color: ", ";\n  cursor: ", ";\n  display: flex;\n  justify-content: space-between;\n  font-weight: ", ";\n  padding: 1em 1em 1em 1.5em;\n  width: 100%;\n\n  &:hover {\n    color: ", ";\n    text-decoration: none;\n    &:not(.active) {\n      background-color: ", ";\n    }\n  }\n\n  &:active {\n    box-shadow: inset ", ";\n    transition: background-color 50ms ease-in, box-shadow 75ms ease-in;\n    &:not(.active) {\n      background-color: ", ";\n    }\n  }\n\n  &.active {\n    background-color: ", ";\n    border-left: 3px solid\n      ", ";\n    box-shadow: ", ";\n    transition: box-shadow 200ms ease-in-out, border 200ms ease-in-out;\n    .nav-icon {\n      color: ", ";\n    }\n  }\n"], ["\n  align-items: center;\n  color: ", ";\n  cursor: ", ";\n  display: flex;\n  justify-content: space-between;\n  font-weight: ", ";\n  padding: 1em 1em 1em 1.5em;\n  width: 100%;\n\n  &:hover {\n    color: ", ";\n    text-decoration: none;\n    &:not(.active) {\n      background-color: ", ";\n    }\n  }\n\n  &:active {\n    box-shadow: inset ", ";\n    transition: background-color 50ms ease-in, box-shadow 75ms ease-in;\n    &:not(.active) {\n      background-color: ", ";\n    }\n  }\n\n  &.active {\n    background-color: ", ";\n    border-left: 3px solid\n      ", ";\n    box-shadow: ", ";\n    transition: box-shadow 200ms ease-in-out, border 200ms ease-in-out;\n    .nav-icon {\n      color: ", ";\n    }\n  }\n"])), function (p) {
  return p.theme.textSecondary;
}, function (p) {
  return (p.className || 'enabled').includes('enabled') ? 'pointer' : 'not-allowed';
}, function (p) {
  return p.theme.fontWeightNormal;
}, function (p) {
  return p.theme.primary;
}, function (p) {
  return p.theme.themeName === 'greenlight' ? p.theme.level5 : p.theme.level2;
}, function (p) {
  return p.theme.boxShadowSmall;
}, function (p) {
  return p.theme.themeName === 'greenlight' ? p.theme.level5 : p.theme.level2;
}, function (p) {
  return p.theme.themeName === 'greenlight' ? p.theme.level5 : p.theme.level1;
}, function (p) {
  return p.theme.themeName === 'dark' ? p.theme.white : p.theme.themeName === 'greenlight' || p.theme.themeName === 'newlight' ? p.theme.primaryB : p.theme.primary;
}, function (p) {
  return p.theme.boxShadowSmall;
}, function (p) {
  return p.theme.primary;
});
var StepHeader = styled(Header4)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-bottom: 0.15em;\n"], ["\n  margin-bottom: 0.15em;\n"])));
var StepIcon = styled(FontAwesomeIcon)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (p) {
  return p.brand ? p.theme[p.brand] : p.theme.textTertiary;
});
var StepIconGroup = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var StepConnector = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  background-color: ", ";\n  content: '';\n  height: calc(2em - 4px);\n  left: calc(50% - 2px);\n  padding: 0;\n  position: absolute;\n  top: calc(-100% + 3px);\n  width: 3px;\n  z-index: 1;\n"], ["\n  background-color: ", ";\n  content: '';\n  height: calc(2em - 4px);\n  left: calc(50% - 2px);\n  padding: 0;\n  position: absolute;\n  top: calc(-100% + 3px);\n  width: 3px;\n  z-index: 1;\n"])), function (p) {
  return p.brand ? p.theme[p.brand] : p.theme.textTertiary;
});

var getIcon = function getIcon(brand) {
  switch (brand) {
    case 'success':
      return faCheckCircle;

    case 'danger':
      return faTimesCircle;

    case 'warning':
      return faExclamationCircle;

    case 'info':
      return faInfoCircle;

    default:
      return faCircle;
  }
};

var WorkflowStep = function WorkflowStep(_a) {
  var brand = _a.brand,
      _b = _a.connect,
      connect = _b === void 0 ? true : _b,
      _c = _a.current,
      current = _c === void 0 ? false : _c,
      name = _a.name,
      onClick = _a.onClick,
      _d = _a.disabled,
      disabled = _d === void 0 ? false : _d,
      props = __rest(_a, ["brand", "connect", "current", "name", "onClick", "disabled"]);

  return React.createElement(Step, Object.assign({
    className: "workflow-step" + (current ? ' active' : '') + " " + (disabled ? ' disabled' : ' enabled'),
    onClick: onClick
  }, props), React.createElement(StepHeader, null, name), React.createElement(StepIconGroup, null, connect && React.createElement(StepConnector, {
    brand: brand
  }), React.createElement(StepIcon, {
    brand: brand,
    icon: getIcon(brand),
    size: "2x"
  })));
};

export default WorkflowStep;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;